/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ReactNode } from 'react';
import { Provider } from 'react-redux';

import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, Theme, ThemeProvider } from '@mui/material/styles';

import { BackendHealthyContainer } from '../containers/BackendHealthyContainer/component';
import { configureStore } from '../store';
import { useCreateTheme } from '../theme';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

export function AppProviders({ children, store }: { children: ReactNode; store: ReturnType<typeof configureStore> }) {
  const appTheme = useCreateTheme();

  return (
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={appTheme}>
          <CssBaseline />
          <BackendHealthyContainer>{children}</BackendHealthyContainer>
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>
  );
}
